import React from 'react';

const FormContainer = (props) => {
    return (
        <div className="demo-section k-content dynmicwhitecntr DynamicFields">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12"> 
                <div className="row example-wrapper">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="card-block">
                            {props.children}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default FormContainer;